// import React from "react";
// import { useRef } from "react";
// import { X } from "lucide-react";
// import moment from "moment";

// const InvoiceSaleModal = ({ open, onClose, sale }) => {
//   const receiptRef = useRef(null);

//   if (!open || !sale) return null;

//   const handlePrint = () => {
//     const receiptContent = receiptRef.current
//       ? receiptRef.current.innerHTML.replace(/undefined|null|blank/g, "")
//       : "";
//     const printWindow = window.open("", "_blank");
//     printWindow.document.write(`
//       <html>
//       <head>
//         <style>
//           body { font-family: calibri, sans-serif; font-size: 12px; margin: 0 auto; padding: 0;}
//           .receipt-container { width: 300px; margin: 0 auto; padding: 5px;}
//           table { width: 100%; border-collapse: collapse; }
//           th, td { text-align: left; padding: 4px; }
//           th { border-bottom: 1px solid #000; }
//         </style>
//       </head>
//       <body onload="window.print(); window.close();">
//         ${receiptContent}
//       </body>
//       </html>
//     `);
//     printWindow.document.close();
//   };

//   const totalPriceSum =
//     sale.details?.reduce(
//       (sum, med) => sum + (Number(med.total_price) || 0),
//       0,
//     ) || 0;
//   const discountPriceSum =
//     sale.details?.reduce(
//       (sum, med) => sum + (Number(med.discount_price) || 0),
//       0,
//     ) || 0;
//   const finalDiscount = (totalPriceSum - discountPriceSum).toFixed(2);

//   return (
//     <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 ml-[240px] ">
//       <div className="bg-white px-8 py-6 rounded-2xl w-[50%] shadow-lg relative max-h-[80vh] overflow-y-auto">
//         <button
//           onClick={onClose}
//           className="absolute top-4 right-4 text-gray-600 hover:text-gray-800"
//         >
//           ✖
//         </button>

//         <h1 className="text-center font-semibold text-gray-800 text-xl">
//           Sale Invoice
//         </h1>
//         <h2 className="text-primary font-bold text-lg mt-4">
//           {sale.customer_name || "N/A"}
//         </h2>

//         <div className="flex flex-col mt-1 gap-1">
//           <h1 className="font-bold text-gray-700 text-sm">
//             Invoice No : <span className="font-normal">{sale.id || "N/A"}</span>
//           </h1>
//           <h1 className="font-bold text-gray-700 text-sm">
//             Invoice Date :{" "}
//             <span className="font-normal">
//               {moment(sale.date).format("ll")}
//             </span>
//           </h1>
//         </div>

//         <div className="flex w-full mt-8">
//           <div className="flex w-full mt-6 overflow-hidden rounded-lg border border-gray-300 shadow-md">
//             <table className="w-full border-collapse">
//               <thead>
//                 <tr className="text-xs font-semibold text-center border-b">
//                   <th className="text-start py-2 w-[3%]">Medicine</th>
//                   <th className="py-2 w-[1%]">Qty</th>
//                   <th className="py-2 w-[3%]">Total Amount</th>
//                   <th className="py-2 w-[3%]">Discounted Amount</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {sale.details && sale.details.length > 0 ? (
//                   sale.details.map((med, index) => (
//                     <tr key={index} className="text-center">
//                       <td className="text-start border-b-2 py-2 text-gray-700 text-sm">
//                         {med.medicine_name || "N/A"}
//                       </td>
//                       <td className="border-b-2 py-2 text-gray-700 text-sm">
//                         {med.quantity || 0}
//                       </td>
//                       <td className="border-b-2 py-2 text-gray-700 text-sm">
//                         {med.total_price || "0.00"}
//                       </td>
//                       <td className="border-b-2 py-2 text-gray-700 text-sm">
//                         {med.discount_price || "0.00"}
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="4" className="text-center text-gray-500 py-4">
//                       No medicines found
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         <div className="flex flex-col justify-end items-end mt-10 gap-1">
//           <div>
//             <h1 className="font-bold text-gray-700 text-sm">
//               Total :{" "}
//               <span className="font-normal">
//                 {totalPriceSum.toFixed(2) || "0.00"}
//               </span>
//             </h1>
//             <h1 className="font-bold text-gray-700 text-sm">
//               Discount : <span className="font-normal">{finalDiscount}</span>
//             </h1>
//             <h1 className="font-bold text-gray-700 text-sm">
//               Bill Amount :{" "}
//               <span className="font-normal">
//                 {discountPriceSum.toFixed(2) || "0.00"}
//               </span>
//             </h1>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default InvoiceSaleModal;

import React, { useRef } from "react";
import moment from "moment";

const InvoiceSaleModal = ({ open, onClose, sale }) => {
  const receiptRef = useRef(null);

  if (!open || !sale) return null;

  const handlePrint = () => {
    const receiptContent = receiptRef.current
      ? receiptRef.current.innerHTML.replace(/undefined|null|blank/g, "")
      : "";
    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
      <html>
      <head>
        <style>
          body { font-family: calibri, sans-serif; font-size: 12px; margin: 0 auto; padding: 0;}
          .receipt-container { width: 300px; margin: 0 auto; padding: 5px;}
          table { width: 100%; border-collapse: collapse; }
          th, td { text-align: left; padding: 4px; }
          th { border-bottom: 1px solid #000; }
        </style>
      </head>
      <body onload="window.print(); window.close();">
        ${receiptContent}
      </body>
      </html>
    `);
    printWindow.document.close();
  };

  const totalPriceSum =
    sale.details?.reduce(
      (sum, med) => sum + (Number(med.total_price) || 0),
      0,
    ) || 0;
  const discountPriceSum =
    sale.details?.reduce(
      (sum, med) => sum + (Number(med.discount_price) || 0),
      0,
    ) || 0;
  const finalDiscount = (totalPriceSum - discountPriceSum).toFixed(2);

  return (
    <div
      className="fixed inset-0 bg-black/50 flex justify-center items-center z-50 p-2 sm:p-4 md:p-6"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl shadow-2xl w-full
          max-w-full sm:max-w-[90%] md:max-w-[70%] lg:max-w-[55%]
          max-h-[95vh] sm:max-h-[90vh] flex flex-col overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* ── Header ── */}
        <div className="bg-[#255A8C] px-4 py-3 sm:px-5 sm:py-4 flex items-center justify-between flex-shrink-0">
          <div className="min-w-0 mr-3">
            <p className="text-[10px] font-medium uppercase tracking-widest text-gray-400">
              Sale Invoice
            </p>
            <p className="text-white font-semibold text-sm sm:text-base leading-tight mt-0.5 truncate">
              {sale.customer_name || "N/A"}
            </p>
          </div>
          <button
            onClick={onClose}
            className="flex-shrink-0 flex items-center justify-center w-8 h-8 rounded-full
              bg-white/10 text-gray-300 hover:bg-white/20 hover:text-white
              transition-all duration-200 text-lg font-bold leading-none"
          >
            &times;
          </button>
        </div>

        {/* ── Info Strip ── */}
        <div className="bg-gray-50 border-b border-gray-100 px-4 py-2.5 sm:px-5 sm:py-3 flex items-center gap-2 sm:gap-3 flex-shrink-0">
          <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-[#255A8C] flex items-center justify-center text-white font-bold text-sm flex-shrink-0">
            {sale.customer_name?.charAt(0)?.toUpperCase() || "C"}
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-xs sm:text-sm font-semibold text-gray-800 truncate">
              {sale.customer_name || "N/A"}
            </p>
            <p className="text-[11px] text-gray-400">
              {sale.details?.length || 0} item(s)
            </p>
          </div>
          <div className="flex flex-col items-end gap-1 flex-shrink-0">
            <span className="text-[10px] sm:text-[11px] font-semibold px-2 py-0.5 sm:px-2.5 sm:py-1 rounded-full bg-blue-50 text-blue-600 border border-blue-100 whitespace-nowrap">
              Invoice #{sale.id || "N/A"}
            </span>
            <span className="text-[10px] text-gray-400 whitespace-nowrap">
              {moment(sale.date).format("ll")}
            </span>
          </div>
        </div>

        {/* ── Scrollable Table ── */}
        <div className="overflow-y-auto overflow-x-auto flex-1 px-3 py-3 sm:px-5 sm:py-4">
          {sale.details && sale.details.length > 0 ? (
            <table className="w-full min-w-[420px] text-xs sm:text-sm border-collapse">
              <thead>
                <tr className="bg-gray-50">
                  {[
                    "#",
                    "Medicine",
                    "Qty",
                    "Total Amount",
                    "Discounted Amount",
                  ].map((col, i) => (
                    <th
                      key={col}
                      className={`text-[9px] sm:text-[10px] font-bold uppercase tracking-widest text-gray-400 px-3 py-2.5 whitespace-nowrap ${
                        i === 0 || i === 1 ? "text-left" : "text-right"
                      }`}
                    >
                      {col}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {sale.details.map((med, index) => (
                  <tr
                    key={index}
                    className="border-b border-gray-100 hover:bg-gray-50 transition-colors"
                  >
                    <td className="px-3 py-2.5 text-gray-400 font-medium whitespace-nowrap">
                      {index + 1}
                    </td>
                    <td className="px-3 py-2.5 text-gray-800 font-medium">
                      {med.medicine_name || "N/A"}
                    </td>
                    <td className="px-3 py-2.5 text-gray-600 text-right whitespace-nowrap">
                      {med.quantity || 0}
                    </td>
                    <td className="px-3 py-2.5 text-gray-700 text-right whitespace-nowrap">
                      {Number(med.total_price || 0).toFixed(2)}
                    </td>
                    <td className="px-3 py-2.5 text-gray-800 font-semibold text-right whitespace-nowrap">
                      {Number(med.discount_price || 0).toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="text-center py-10 text-gray-400 text-sm">
              No medicines found for this invoice.
            </div>
          )}
        </div>

        {/* ── Totals Footer ── */}
        <div className="border-t border-gray-100 bg-gray-50 px-4 py-3 sm:px-5 sm:py-4 flex-shrink-0">
          <div className="flex justify-end">
            <div className="w-full sm:w-64 space-y-2">
              <div className="flex justify-between items-center">
                <span className="text-[11px] font-bold uppercase tracking-widest text-gray-400">
                  Subtotal
                </span>
                <span className="text-[12px] text-gray-700 font-medium tabular-nums">
                  {totalPriceSum.toFixed(2)}
                </span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-[11px] font-bold uppercase tracking-widest text-gray-400">
                  Discount
                </span>
                <span className="text-[12px] text-red-500 font-medium tabular-nums">
                  - {finalDiscount}
                </span>
              </div>
              <div className="border-t border-gray-200 pt-2 flex justify-between items-center">
                <span className="text-[11px] font-bold uppercase tracking-widest text-gray-600">
                  Bill Amount
                </span>
                <span className="text-[15px] font-bold text-[#F07F1C] tabular-nums">
                  {discountPriceSum.toFixed(2)}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceSaleModal;
